/* eslint-disable */
export default {
  methods: {
    initOneSignal: function (selectedLocation) {
      // if cordova is present then the device being used should be a mobile
      if (window.cordova) {
        // NOTE: Update the setAppId value below with your OneSignal AppId.
        window.plugins.OneSignal.initialize(
          "4e3d2cd9-3315-42db-8948-0ae63a1ad2d3"
        );

        // function to handle the opening of a notification
        window.plugins.OneSignal.Notifications.addEventListener(
          "click",
          (event) => {
            const redirectUrl = event.notification.additionalData.redirectURL;

            if (redirectUrl) {
              window.location.replace(redirectUrl);
            }
          }
        );

        // method to prompt the user for push notifications
        window.plugins.OneSignal.Notifications.requestPermission(false).then(
          (accepted) => {
            console.log("User accepted notifications: " + accepted);
          }
        );

        // method for sending a custom tag, uncomment to use
        if (selectedLocation && selectedLocation.length > 0) {
          window.plugins.OneSignal.User.addTag("location", selectedLocation);
        }
      }
    },
    setStatusBarStyles: function () {
      if (window.cordova) {
        // NOTE: Update the setAppId value below with your OneSignal AppId.
        window.plugins.OneSignal.initialize(
          "4e3d2cd9-3315-42db-8948-0ae63a1ad2d3"
        );

        // Setting the status bar to appear above the app content
        StatusBar.overlaysWebView(true);

        // Setting the status bar background color
        StatusBar.backgroundColorByHexString("#6d72b6");

        // Sets the status bar text color to a default dark color, which is suitable for light-colored backgrounds
        StatusBar.styleDefault();
      }
    },
    updateOneSignalLocation: function (selectedLocation) {
      if (window.cordova) {
        window.plugins.OneSignal.initialize(
          "4e3d2cd9-3315-42db-8948-0ae63a1ad2d3"
        );

        if (selectedLocation && selectedLocation.length > 0) {
          window.plugins.OneSignal.User.addTag("location", selectedLocation);
        }
      }
    },
  },
};
/* eslint-enable */